export default {
  primary: '#002c38',
  secondary: '#69737a',
  tertiary: '#FAF566',
  sidebarBackground: '#ffffff',
  sidebarLink: '#002c38',
  sidebarChildLink: '#002c38',
  navbarBackground: '#ffffff',
  navbarLink: '#002c38',
  headingLight: '#252525',
  headingDark: '#ffffff',
  subheadingLight: '#252525',
  subheadingDark: '#ffffff',
  textLight: '#252525',
  textDark: '#ffffff',
  linkLight: '#002c38',
  linkDark: '#ffffff',
  info: '#0073bd',
  success: '#198838',
  warning: '#fcc200',
  error: '#d82023',
}
